import React from "react";
import { slugify } from "@utils";
import ProductCard from "./ProductCard";
import pluralize from "pluralize";

const Sugestions = ({ products }) => {
  return (
    <div className="Section Section--results">
      <div className="Section__header">
        <h4 className="heading">
          Personalized {pluralize("Product", products.length)}
        </h4>
      </div>
      <div className="Loop">
        {products.map((product) => (
          <ProductCard
            product={product}
            key={product.handle}
            title={product.cardTitle}
          />
        ))}
      </div>
      <h4 className="heading">
        <b>Next Step</b>: Shop your shade!
      </h4>
    </div>
  );
};

export default Sugestions;
